module.exports = "https://static.wanderu.com/static/media/chiku-newsletter.43def637.png";